<template lang="pug">
  .div
    .columns
      h3.title Editar Operador
    .columns
      .column.is-4
        .field
          label.label Nombre
            .control.has-icons-left.has-icons-right
              input.input.is-primary(
                type='text', 
                placeholder='Nombre..',
                v-model="nombre"
              )
      .column.is-4
        .field
          label.label Identificación
            .control.has-icons-left.has-icons-right
              input.input.is-primary(
                type='text', 
                placeholder='Identificación..',
                v-model="identificacion"
              )
      .column.is-4
        .field
          label.label Teléfono
            .control.has-icons-left.has-icons-right
              input.input.is-primary(
                type='text', 
                placeholder='Teléfono..',
                v-model="telefono"              
              )
    .columns
      .column.is-2
        a.button.is-block(@click="cancelAdd")
          | Cancelar 
      .column.is-2
        a.button.is-black.is-block(@click="checkForm")
          | Guardar 
    .columns(v-show="datosFaltantes.length > 0")
      .notification
          .field.is-grouped.is-grouped-multiline
            .control(v-for="datosF in datosFaltantes")
              .tags
                span.tag.is-danger.is-light {{ datosF }}
</template>

<script>
  import sca_tuxpanServices from '@/services/sca/tpa.js' 
  import moment from 'moment'
  import { mapState } from 'vuex'

  export default {
    name: 'FormOperadoresEditar',
    data() {
      return {
        nombreInicial: this.operadorEditar[0].nombre,
        identificacionInicial:  this.operadorEditar[0].identificacion,
        telefonoInicial: this.operadorEditar[0].telefono,

        nombre: this.operadorEditar[0].nombre,
        identificacion:  this.operadorEditar[0].identificacion,
        telefono:  this.operadorEditar[0].telefono,
        datosFaltantes: []
      }
    },
    methods: {
      checkForm() {
        if (this.nombre) {
          this.modificarInformacion()
        } else {
          this.datosFaltantes = []
          if (!this.nombre) {
            this.datosFaltantes.push('El nombre es requerido.')
          }
          if (!this.identificacion) {
            this.datosFaltantes.push('La Identificacion es requerido.')
          }
          if (!this.telefono) {
            this.datosFaltantes.push('El teléfono es requerido.')
          }
        }
      },
      modificarInformacion(){
        const telefono = this.telefono ? this.telefono : ''
        sca_tuxpanServices.updateOperador(this.operadorEditar[0].id, this.nombre, this.identificacion, telefono)
          .then( resp => {
            if (resp.success) {
              this.checkCambios()
              let toast = this.$toasted.show(`El Operador ha sido Modificado.`, { 
                theme: "toasted-primary", 
                position: "bottom-right", 
                duration : 3000,
                iconPack: 'fontawesome',
                icon: 'ban',
                action : {
                  text : 'Ok',
                  onClick : (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
              })
              this.nombre = null
              this.clave = null
              this.rfc = null
              this.$emit('closeForm','saved')
            } else {
              let toast = this.$toasted.show(`Error: ${resp.respuesta}`, { 
                theme: "toasted-primary", 
                position: "bottom-right", 
                duration : 3000,
                iconPack: 'fontawesome',
                icon: 'ban',
                action : {
                  text : 'Ok',
                  onClick : (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
              })
            }
          })
          .catch(e => console.log(e))
      },
      cancelAdd () {
        this.datosFaltantes = []
        this.nombre = null
        this.identificacion = null
        this.telefono = null
        this.$emit('closeForm','close')
      },
      checkCambios(){
        this.cambiosRealizados=[]
        
        if (this.nombre != this.nombreInicial) {
          this.cambiosRealizados.push(`Nombre Ant: ${this.nombreInicial} - Nombre nuevo: ${this.nombre} | `)
        }
        if (this.identificacion != this.identificacionInicial) {
          this.cambiosRealizados.push(`Identidicación ant: ${this.identificacionInicial} - Identificación nueva: ${this.identificacion} | `)
        }
        if (this.telefono != this.telefonoInicial) {
          this.cambiosRealizados.push(`Teléfono Ant: ${this.telefonoInicial} - Teléfono nuevo: ${this.telefono} `)
        }

        sca_tuxpanServices.addEdicion('N/A', moment().format('YYYY-MM-DD'), this.userLogin.usuario, this.cambiosRealizados, 'Actualizar información de operador')
          .then( data => {
            console.log('Cambios registrados')
          })
          .catch( e => {
            this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'Ok')
            this.isLoading = false
          })
      }
    },
    props: {
      operadorEditar: {
        type: Array,
        default: []
      },
    },
    computed:{ ...mapState(['userLogin']) }
  }
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/FormOperadoresEditar.vue